import {
  Component,
  OnInit,
  ViewChild,
  QueryList,
  ViewChildren,
} from "@angular/core";
import { Subscription, from, Observable } from "rxjs";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { KmlUtils } from "src/app/shared/utils/kml-utils";
import { FacadeSesionService } from "src/app/services/facade-sesion.service";
import { Obra } from "src/app/models/entities/obra";
import { map, concatMap, filter, toArray, take } from "rxjs/operators";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { CatalogoService } from "src/app/services/catalogo.service";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { Estado } from "src/app/models/entities/estado";
import { ObraDTO } from "src/app/models/dtos/obra-dto";
import { ElementoCatalogo } from "src/app/models/entities/elemento-catalogo";
import { ObraService } from "src/app/services/obra.service";
import { TipoConsultaEnum } from "src/app/shared/enums/tipo-consulta-enum.enum";
import { Capa } from "src/app/models/entities/capa";
import { CapaService } from "src/app/services/capa.service";
import { Segmento } from "src/app/models/entities/segmento";
import { SegmentoService } from "src/app/services/segmento.service";
import { Router } from "@angular/router";
import { LoaderService } from "src/app/services/loader.service";
import { Table } from "primeng/table";
import { MultiSelect } from "primeng/multiselect";

@Component({
  selector: "consultar-obras",
  templateUrl: "./consultar-obras.component.html",
  styleUrls: ["./consultar-obras.component.scss"],
})
export class ConsultarObrasComponent implements OnInit {
  @ViewChild("modalConfirmacion")
  public modal: any;
  public modalActivo: NgbModalRef;
  @ViewChild("dt")
  private table: Table;

  @ViewChildren("ne") nombreEstado: QueryList<MultiSelect>;
  @ViewChildren("nto") tipoObra: QueryList<MultiSelect>;
  @ViewChildren("ntp") tipoPrioridad: QueryList<MultiSelect>;
  @ViewChildren("nda") direccionAdjunta: QueryList<MultiSelect>;

  public obraSeleccionada: ObraDTO;
  public suscripcionObras: Subscription;
  public cols: any[] = [
    { field: "nombreEstado", header: "Estado" },
    { field: "nombreTipoObra", header: "Tipo obra" },
    { field: "nombreTipoPrioridad", header: "Prioridad" },
    { field: "direccionAdjunta", header: "Dirección adjunta" },
    { field: "nombreObra", header: "Nombre obra" },
    // { field: 'nombreTramoLicitacion', header: 'Nombre Licitación' },
    { field: "obra.inversionTotal", header: "Costo total" },
    { field: "obra.longitudTotal", header: "Meta total" },
    { field: "obra.avanceFisicoGlobal", header: "Avance físico global" },
    {
      field: "obra.avanceFinancieroGlobal",
      header: "Avance financiero global",
    },
  ];

  public catEstados: Estado[] = [];
  public catTiposObra: ElementoCatalogo[] = [];
  public catTipoPrioridad: any[] = [];
  public catDireccionAdjunta: any[] = [];

  public obrasLevantamientos: LevantamientoObra[] = [];
  public obras: Obra[] = [];
  public obrasProceso: ObraDTO[] = [];
  public elementosObra: Segmento[] = [];
  public tipoConsulta: string = "";
  public readonly TIPO_OBRA_PROCESO: string = "0";

  public sumaCostoTotal: number = 0;
  public sumaMetaTotal: number = 0;
  public sumaAvanceFisicoTotal: number = 0;
  public sumaAvanceFinancieroTotal: number = 0;
  public sumaObrasDireccion = 0;
  public sumaObrasFederales = 0;
  public sumaObrasRurales = 0;

  public constructor(
    private obraService: ObraService,
    private ngbModalService: NgbModal,
    private kmlUtils: KmlUtils,
    private facadeSesionService: FacadeSesionService,
    private levantamientoObraService: LevantamientoObraService,
    private catalogoService: CatalogoService,
    private segmentoService: SegmentoService,
    private capaService: CapaService,
    private router: Router,
    private loaderService: LoaderService
  ) {}

  public async ngOnInit() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad(
      "Consulta de obras"
    );
    await this.obtenerCatalogos();
    await this.obtenerObras();
    await this.calcularTotales();
  }

  public async calcularTotales() {
    this.sumaObrasDireccion = this.obrasProceso.reduce(
      (prev, curr) => prev + 1,
      0
    );
    this.sumaObrasFederales = this.obrasProceso.reduce(
      (prev, curr) =>
        prev + (curr.direccionAdjunta === "Carreteras Federales" ? 1 : 0),
      0
    );
    this.sumaObrasRurales = this.obrasProceso.reduce(
      (prev, curr) =>
        prev + (curr.direccionAdjunta === "Caminos Rurales" ? 1 : 0),
      0
    );
    this.sumaCostoTotal = this.obrasProceso.reduce(
      (prev, curr) => prev + curr.obra.inversionTotal,
      0
    );
    this.sumaMetaTotal = this.obrasProceso.reduce(
      (prev, curr) => prev + curr.obra.longitudTotal,
      0
    );
    this.sumaAvanceFisicoTotal = this.obrasProceso.reduce(
      (prev, curr) => prev + curr.obra.avanceFisicoGlobal,
      0
    );
    this.sumaAvanceFinancieroTotal = this.obrasProceso.reduce(
      (prev, curr) => prev + curr.obra.avanceFinancieroGlobal,
      0
    );
  }

  public async obtenerCatalogos() {
    this.catEstados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(
        take(1),
        map((estados: Estado[]) => {
          return estados.map(
            (estado: Estado) =>
              ({
                label: estado.nombre,
                value: estado.nombre,
              } as any)
          );
        })
      )
      .toPromise();

    this.catTiposObra = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(
        take(1),
        map((tiposObra: ElementoCatalogo[]) => {
          return tiposObra.map(
            (tipoObra: ElementoCatalogo) =>
              ({
                label: tipoObra.nombre,
                value: tipoObra.nombre,
              } as any)
          );
        })
      )
      .toPromise();

    this.catTipoPrioridad = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD)
      .pipe(
        take(1),
        map((tiposObra: ElementoCatalogo[]) => {
          return tiposObra.map(
            (tipoObra: ElementoCatalogo) =>
              ({
                label: tipoObra.nombre,
                value: tipoObra.nombre,
              } as any)
          );
        })
      )
      .toPromise();

    this.catDireccionAdjunta = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.DIRECCIONES_ADJUNTAS)
      .pipe(
        take(1),
        map((tiposObra: ElementoCatalogo[]) => {
          return tiposObra.map(
            (direccionAdjunta: ElementoCatalogo) =>
              ({
                label: direccionAdjunta.nombre,
                value: direccionAdjunta.nombre,
              } as any)
          );
        })
      )
      .toPromise();
  }

  public filtrarPorTipoObra(
    tipoConsulta: string,
    keyCatTipoObra: string
  ): boolean {
    if (tipoConsulta === TipoConsultaEnum.ADMINISTRACION) {
      return true;
    }
    if (tipoConsulta === TipoConsultaEnum.PROCESO) {
      return keyCatTipoObra === tipoConsulta ? true : false;
    }
    if (tipoConsulta === TipoConsultaEnum.PLANEACION) {
      return keyCatTipoObra === tipoConsulta ? true : false;
    }
  }

  public obtenerDatosFiltrados(valores: any) {
    let valoresFiltrados = valores.filteredValue;
    this.sumaObrasDireccion = valoresFiltrados.reduce(
      (prev, curr) => prev + 1,
      0
    );
    this.sumaObrasFederales = valoresFiltrados.reduce(
      (prev, curr) =>
        prev + (curr.direccionAdjunta === "Carreteras Federales" ? 1 : 0),
      0
    );
    this.sumaObrasRurales = valoresFiltrados.reduce(
      (prev, curr) =>
        prev + (curr.direccionAdjunta === "Caminos Rurales" ? 1 : 0),
      0
    );
    this.sumaCostoTotal = valoresFiltrados.reduce(
      (prev, curr) => prev + curr.obra.inversionTotal,
      0
    );
    this.sumaMetaTotal = valoresFiltrados.reduce(
      (prev, curr) => prev + curr.obra.longitudTotal,
      0
    );
    this.sumaAvanceFisicoTotal = valoresFiltrados.reduce(
      (prev, curr) => prev + curr.obra.avanceFisicoGlobal,
      0
    );
    this.sumaAvanceFinancieroTotal = valoresFiltrados.reduce(
      (prev, curr) => prev + curr.obra.avanceFinancieroGlobal,
      0
    );
  }

  public reiniciarFiltros(event, dt) {
    this.nombreEstado["_results"].forEach((ds) => {
      ds.value = null;
      ds.updateLabel();
    });
    dt.filter("", "nombreEstado", "contains");

    this.tipoObra["_results"].forEach((ds) => {
      ds.value = null;
      ds.updateLabel();
    });
    dt.filter("", "nombreTipoObra", "contains");

    this.tipoPrioridad["_results"].forEach((ds) => {
      ds.value = null;
      ds.updateLabel();
    });
    dt.filter("", "nombreTipoPrioridad", "contains");

    this.direccionAdjunta["_results"].forEach((ds) => {
      ds.value = null;
      ds.updateLabel();
    });
    dt.filter("", "direccionAdjunta", "contains");

    this.table.reset();

    this.calcularTotales();
  }

  public abrirLarguillo(keyLevantamientoObra: string): void {
    this.router.navigate(["/tablero/ver-larguillo", keyLevantamientoObra], {
      skipLocationChange: true,
    });
  }

  public async obtenerObras(): Promise<any> {
    let catalogoTipoObra: ElementoCatalogo[] = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS)
      .pipe(take(1))
      .toPromise();
    let catalogoPrioridad: ElementoCatalogo[] = await this.catalogoService
      .obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD)
      .pipe(take(1))
      .toPromise();
    let estados: Estado[] = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
    let catalogoDireccionAdjunta: ElementoCatalogo[] =
      await this.catalogoService
        .obtenerCatalogo<ElementoCatalogo>(
          RutaCatalogoEnum.DIRECCIONES_ADJUNTAS
        )
        .pipe(take(1))
        .toPromise();
    this.tipoConsulta =
      await this.facadeSesionService.usuarioEnSesionService.obtenerKeyTipoObra();
    this.obras = await this.obraService.findAll().pipe(take(1)).toPromise();

    this.obrasLevantamientos = await this.levantamientoObraService
      .findAll()
      .pipe(take(1))
      .toPromise();
    for (let index = 0; index < this.obras.length; index++) {
      let obra = this.obras[index];
      let keyLevObra = this.obras[index].keyLevantamientoObra;
      let levObra = this.obrasLevantamientos.find(
        (l: LevantamientoObra) => l.key === keyLevObra
      );
      let keyTipoPrioridad = obra.keyCatTipoPrioridad;
      let keyTipoObra = levObra.keyCatTipoObra;
      let keyEstado = levObra.keyCatEstado;
      let keyDireccion = levObra.keyCatDireccionAdjunta;
      let obraDto: ObraDTO = {
        nombreEstado: estados.find((e: Estado) => e.key === keyEstado).nombre,
        direccionAdjunta: catalogoDireccionAdjunta.find(
          (e: any) => e.key === keyDireccion
        ).nombre,
        nombreObra: levObra.nombreObra,
        nombreTipoObra: catalogoTipoObra.find(
          (c: ElementoCatalogo) => c.key === keyTipoObra
        ).nombre,
        nombreTipoPrioridad: catalogoPrioridad.find(
          (c: ElementoCatalogo) => c.key === keyTipoPrioridad
        ).nombre,
        nombreTramoLicitacion: levObra.nombreTramoLicitacion,
        keyCatDireccionAdjunta: levObra.keyCatDireccionAdjunta,
        obra,
      };
      this.obrasProceso.push(obraDto);
    }
  }

  public confirmarEliminacion(obra: ObraDTO): void {
    this.obraSeleccionada = obra;
    this.modalActivo = this.ngbModalService.open(this.modal, {
      centered: true,
      windowClass: "modal-eliminacion",
    });
  }

  public eliminar(): void {
    this.obraService
      .remove(this.obraSeleccionada.obra.key)
      .catch((error) => {
        console.error("Error al borrar la ficha técnica.", error);
      })
      .finally(() => {
        this.obrasProceso = this.obrasProceso.filter(
          (obraEliminada: ObraDTO) =>
            obraEliminada.obra.key !== this.obraSeleccionada.obra.key
        );
        this.cerrarModal();
      });
  }

  public async descargarKML(obraSeleccionada: ObraDTO) {
    this.elementosObra = await this.capaService
      .findByKeyLevantamientoObra(obraSeleccionada.obra.keyLevantamientoObra)
      .pipe(
        take(1),
        concatMap((capas: Capa[]) =>
          from(capas).pipe(
            concatMap((capa: Capa) =>
              this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
            )
          )
        ),
        take(1)
      )
      .toPromise();
    this.kmlUtils.descargarKml(this.elementosObra[0].coordenadas);
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

  public ngOnDestroy(): void {
    if (this.suscripcionObras) {
      this.suscripcionObras.unsubscribe();
    }
  }

  abrirReporteador(keyLevantamiento: string) {
    // window.location.href = `http://198.37.117.136/Default.aspx?keyLevantamiento=${keyLevantamiento}`;
    window.open(
      `https://198.37.117.136/2021/ficha2021.aspx?keyLevantamiento=${keyLevantamiento}`,
      "_blank"
    );
  }
}
